import { render } from "./MyPatientDetail.vue?vue&type=template&id=15e1261f&ts=true"
import script from "./MyPatientDetail.vue?vue&type=script&lang=ts"
export * from "./MyPatientDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__